import { IWorkBenchLayout } from '../contracts';
import { searchObject } from './search-object';

export const getElements = (fullStack: IWorkBenchLayout, type: string) => {
	let copy = JSON.parse(JSON.stringify(fullStack)) as IWorkBenchLayout;
	const ok = searchObject(
		copy,
		function (value) {
			return value != null && value != undefined && value.type === type && Object.keys(value.props ?? {}).length > 0;
		},
		undefined,
		undefined,
		undefined,
		undefined
	);
	return ok.map(o => o.value);
};

export const getElementsNested = (fullStack: IWorkBenchLayout, id: string) => {
	let copy = JSON.parse(JSON.stringify(fullStack)) as IWorkBenchLayout;
	const ok = searchObject(
		copy,
		function (value) {
			return value != null && value != undefined && value.id == id && Object.keys(value.props ?? {}).length > 0;
		},
		undefined,
		undefined,
		undefined,
		undefined
	);
	return ok.map(o => o.value);
};

export const getElementsOfTypeNested = (fullStack: IWorkBenchLayout, type: string) => {
	let copy = JSON.parse(JSON.stringify(fullStack)) as IWorkBenchLayout;
	const ok = searchObject(
		copy,
		function (value) {
			return value != null && value != undefined && value.type == type && Object.keys(value.props ?? {}).length > 0;
		},
		undefined,
		undefined,
		undefined,
		undefined
	);
	return ok.map(o => o.value);
};

/**Function to get all the elements of an array of block types */
export const getElementsOfTypesNested = (fullStack: IWorkBenchLayout, types: string[]) => {
	let copy = JSON.parse(JSON.stringify(fullStack)) as IWorkBenchLayout;
	const ok = searchObject(
		copy,
		function (value) {
			return value != null && value != undefined && types.some(t => t === value.type) && Object.keys(value.props ?? {}).length > 0;
		},
		undefined,
		undefined,
		undefined,
		undefined
	);
	return ok.map(o => o.value);
};
